import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  validateRequire,
  validateNumberRequire,
  validateRequireSetValue,
  validateRequireSetValueArray,
  validateRequireSetValueArrayMatrix,
  validateRequireSetValueMultipleChoiceMultiple,
  validateRequireSetValueMultipleChoiceOne,
} from '../Utility/RequireAndValidate';
import SingleLineTextComponent from '../Components/SingleLineTextComponent';
import MultipleLineTextComponent from '../Components/MultipleLineTextComponent';
import MultipleChoiceSingleLineTextComponent from '../Components/MultipleChoiceSingleLineTextComponent';
import {
  autoNextCheckQuestion,
  addAutoNextToStore,
  removeAutoNextToStore,
} from '../Utility/RequireAndValidateAutoNext';
import {
  SINGLELINETEXT,
  MULTIPLELINETEXT,
  DISPLAYMESSAGE,
  NUMBER,
  RANKING,
  RATING,
  RATINGSCALE,
  DROPDOWNLIST,
  NETPROMOTORSCORE,
  MULTIPLECHOICEONE,
  MULTIPLECHOICEMULTIPLE,
  MULTIPLECHOICESINGLELINETEXT,
  PHONE_SINGLELINETEXT,
  PAGE,
} from '../Utility/TypeValues';
import {
  setConductSurveyFlowQ5,
  setConductQuestionRandom,
  setLanguages,
  setConductSurveyQuestions,
  setConductCountryOptions,
  setConductFilterChoicesQ2_1,
} from '../Actions/ConductAction';
import DisplayMessageComponent from '../Components/DisplayMessageComponent';
import DropdownListComponent from '../Components/DropdownListComponent';
import MultipleChoiceMultipleComponent from '../Components/MultipleChoiceMultipleComponent';
import MultipleChoiceOneComponent from '../Components/MultipleChoiceOneComponent';
import NetPromotorScoreComponent from '../Components/NetPromotorScoreComponent';
import NumericComponent from '../Components/NumericComponent';
import RankingComponent from '../Components/RankingComponent';
import RatingComponent from '../Components/RatingComponent';
import RatingScaleComponent from '../Components/RatingScaleComponent';
import GroupsContainer from './GroupsContainer';
import { setWrapper } from '../Actions/AnswerAction';
import Exp from '../Expression/expression';
import { GROUP, QUESTION } from '../Utility/TypeValues';
import { isNullOrUndefined } from '../Utility/index';
import PhoneComponent from '../Components/PhoneComponent';
import json from '../Mock/choices.json';
import store from 'src/store';
import {
  CONDUCT_QUESTION_FILTER_CHOICES_Q2,
  CONDUCT_QUESTION_FILTER_CHOICES_Q2_1,
  CONDUCT_QUESTION_FILTER_CHOICES_Q3_TOURIST,
  CONDUCT_QUESTION_FILTER_CHOICES_Q6,
  CONDUCT_QUESTION_FILTER_CHOICES_Q6_TOURIST,
} from 'src/ActionTypes/ConductType';
import { removeAnswerAction } from 'src/Utility/ConditionValidator';
class NodeContainer extends Component {
  constructor(props) {
    super(props);
    this.getAnswer = this.getAnswer.bind(this);
    this.state = {
      surveyFlow: null, // เก็บคำถามที่ถูกสุ่ม
      // survetFlowQ5: null,
      currentNodeKey: null, // เก็บ elementKey ของ currentNode
    };
  }

  componentDidMount() {
    this.generateSurveyFlow();
    this.setFilterChoicesQ2();
    this.setFilterChoicesQ6();
    this.setFilterChoicesQ3Tourist();
    this.setFilterChoicesQ6Tourist();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.conduct.currentNode?.elementKey !==
      this.props.conduct.currentNode?.elementKey
    ) {
      this.generateSurveyFlow();
    }
  }

  generateSurveyFlow = () => {
    const { questions, answers, conduct, nodes } = this.props;
    let newQuestions = questions;
    let context = Exp.survey_conduct_context(
      newQuestions,
      answers,
      conduct.contextVariables,
    );
    const currentNode = conduct.currentNode;

    if (currentNode.elementKey === '748C8E3D-D149-4A56-A90B-23D838F7D9B7') {
      const arrAnswers = [
        // 'F48C6761-41F6-4B45-AB48-52D7163A61BD', // Siam Center (สยาม เซ็นเตอร์)
        // 'DE5506A4-DB42-4619-9C5C-67A815E75FF8', // Siam Discovery (สยาม ดิสคัฟเวอรี่)
        // '09943075-6104-4889-ACB8-126B9BE97D67', // Siam Paragon (สยาม พารากอน)
        '2793D6A3-9B29-4B1A-B743-D270CCA4BE32', // Central World (เซ็นทรัลเวิลด์)
        'E157B724-AEBA-4DDE-9F8C-93AEF06CD7D3', // Emporium (เอ็มโพเรียม)
        '54E410D2-205A-4E9F-AEE7-0557E95433DA', // EmQuartier (เอ็มควอเทียร์)
        'D3EEC220-9F54-456E-ACC9-F543417D4DCA', // EMSPHERE (เอ็มสเฟียร์)
        '254CC22C-D2AE-46D4-984F-F333E679A762', // Central Chidlom (เซ็นทรัลชิดลม)
        'BA770694-B54A-45A0-A7A6-D5DFCC13BF02', // Central Embassy (เซ็นทรัล เอ็มบาสซี)
        // 'C8DAE34B-93D2-4196-B07E-6356DC788E81', // ICONSIAM (ไอคอนสยาม)
        // '4CD52F8C-4D06-4E66-8BF3-3ED008088FCC', // Gaysorn Village (เกษรวิลเลจ)
        // '49FB2B20-D6D9-4592-B0E7-2B90AB362E46', // ICS (ไอซีเอส)
        'CDE19227-5903-4A88-B44B-C074EF5A87F1', // ONE BANGKOK (วัน แบงค็อก)
        // '9E1DD7A0-5E79-4A01-9A31-23A19111C8BF', // MegaBangna (เมกาบางนา)
        // '1DCB7714-772B-4B75-9212-739660FB8675', // Central Ladprao (เซ็นทรัลลาดพร้าว)
      ];

      const filteredNodes = nodes.filter(
        (node) =>
          node.type === QUESTION &&
          Exp.run_object_context(node.condition, context),
      );

      // ถ้า filteredNodes ไม่มีใน arrAnswers ให้ข้ามเลย
      const filteredNodesFlow = filteredNodes.filter((node) => {
        return arrAnswers.includes(node.elementKey);
      });

      if (filteredNodesFlow.length === 0) {
        this.props.setConductSurveyFlowQ5([]);
        this.setState({
          survetFlowQ5: [],
          currentNodeKey: currentNode.elementKey,
        });
        return;
      }

      if (filteredNodes.length < 3) {
        this.setState({
          survetFlowQ5: filteredNodes,
          currentNodeKey: currentNode.elementKey,
        });
        this.props.setConductSurveyFlowQ5(filteredNodes);
      } else {
        if (conduct.questionRandom) {
          // สุ่มใหม่ ลบ answer เก่าออก
          arrAnswers.forEach((elementKey) => {
            if (answers[elementKey]) {
              delete answers[elementKey];
            }
          });

          this.props.setConductQuestionRandom(false);
          const firstNode = filteredNodes[0];
          const otherNodes = filteredNodes.slice(1);

          // otherNodes ต้องเลือกตัวที่มีอยู่ใน arrAnswers
          const filteredOtherNodes = otherNodes.filter((node) =>
            arrAnswers.includes(node.elementKey),
          );

          const randomNodes = filteredOtherNodes
            .sort(() => 0.5 - Math.random())
            .slice(0, 2);

          this.setState({
            survetFlowQ5: [firstNode, ...randomNodes],
            currentNodeKey: currentNode.elementKey,
          });
          this.props.setConductSurveyFlowQ5([firstNode, ...randomNodes]);
        } else {
          this.props.setConductQuestionRandom(false);
          this.setState({
            survetFlowQ5: filteredNodes.slice(0, 3),
            currentNodeKey: currentNode.elementKey,
          });
        }
      }
    } else {
      this.setState({
        surveyFlow: nodes,
        currentNodeKey: currentNode.elementKey,
      });
    }
  };

  getLocation = (id) => {
    let selectedLocation = '';
    if (Number(id) === 0) {
      selectedLocation = 'Siam Piwat';
    } else if (Number(id) <= 9 && Number(id) !== 0) {
      selectedLocation = 'Siam Paragon';
    } else if (Number(id) > 9 && Number(id) < 16) {
      selectedLocation = 'Siam Center';
    } else if (Number(id) >= 16 && Number(id) <= 21) {
      selectedLocation = 'Siam Discovery';
    } else if (Number(id) > 21 && Number(id) <= 29) {
      selectedLocation = 'ICONSIAM';
    } else {
      selectedLocation = 'ICS';
    }

    return selectedLocation;
  };

  shuffleArraySection(arr, start, end) {
    const section = arr.slice(start, end + 1); // ดึงค่าที่ต้องการสุ่ม
    section.sort(() => Math.random() - 0.5); // สุ่มค่าในช่วงนั้น
    arr.splice(start, section.length, ...section); // นำค่าที่สุ่มแล้วกลับไปใส่ที่เดิม
  }

  setFilterChoicesQ2 = () => {
    const { answers, conduct } = this.props;
    const { currentNode } = conduct;
    const pathParts = window.location.pathname.split('/');
    const id = pathParts[1]; // index 0 คือ '', index 1 คือ '1'

    if (currentNode.elementKey === 'EA04AC7D-D130-46D8-A2FB-942E7146A6C1') {
      // remove answer Q2.1
      removeAnswerAction('7152F1D7-5956-4C76-9602-9390F5C2AA47');
    }
    if (currentNode.elementKey === 'F4E399AA-D0E0-47DE-B793-ACC53FAB4ECF') {
      // remove answer Q2.1
      removeAnswerAction('C0E8432A-F51F-4674-A2D7-531C0B9FD823');
    }

    // Q7 remove answer Q8.1, Q8.2
    if (currentNode.elementKey === 'AFCC2F12-C51E-4F75-8244-D85A2478C419') {
      removeAnswerAction('6FB0DD76-D282-4458-A64B-CAAE23C5A9F0');
      removeAnswerAction('BB1C8884-3814-4F8F-B23A-64991F8A9B32');
    }

    const answerId = '80992878-021B-41D8-B2D3-9DE434557BA4';
    const checkedItems =
      answers[answerId]?.value?.filter((item) => item.checkState) || [];

    const selectedChoiceKeys = checkedItems.map((item) => item.elementKey);

    const selectedLocation = this.getLocation(id);

    const locationData = json.location;
    const question2 = json.question2;
    const question2_1 = json.question2_1;

    const filterQ2 = question2.filter((q) => {
      const key = Object.keys(q)[0];

      // If selectedLocation is not 'ICS', remove the object with the specific key
      if (
        selectedLocation === 'Siam Piwat' &&
        key === '931190AE-F5E6-4855-B563-BCCBE78AE677' // staff
      ) {
        return true;
      } else if (
        selectedLocation !== 'ICS' &&
        key === '931190AE-F5E6-4855-B563-BCCBE78AE677'
      ) {
        return false;
      } else if (
        selectedLocation === 'ICS' &&
        key === 'E4B2196F-365A-437C-839F-A01DEC544B34'
      ) {
        return false;
      }

      return true;
    });

    store.dispatch({
      type: CONDUCT_QUESTION_FILTER_CHOICES_Q2,
      filterChoicesQ2: filterQ2,
    });

    // 1. ดึง code list ของ location ที่เลือก
    const locationCodes =
      locationData.find((loc) => Object.keys(loc)[0] === selectedLocation)?.[
        selectedLocation
      ]?.code || [];

    // 2. รวม code จากทุกช้อยที่เลือก
    let allSelectedCodes = [];

    selectedChoiceKeys.forEach((choiceKey) => {
      const choiceObj = filterQ2.find((obj) => obj[choiceKey]);
      if (choiceObj) {
        const codes = choiceObj[choiceKey].codes;
        allSelectedCodes = allSelectedCodes.concat(codes);
      }
    });

    // 3. หาค่าเฉพาะ (ไม่ซ้ำ)
    const uniqueSelectedCodes = [...new Set(allSelectedCodes)];

    // 4. filter เฉพาะ code ที่มีอยู่ใน location
    const matchedCodes = uniqueSelectedCodes.filter((code) =>
      locationCodes.includes(code),
    );

    // 5. map code → elementKey
    const codeToElementKeyMap = question2_1.reduce((acc, obj) => {
      acc[obj.code] = obj.elementKey;
      return acc;
    }, {});

    const matchedElementKeys = matchedCodes.map(
      (code) => codeToElementKeyMap[code],
    );

    store.dispatch({
      type: CONDUCT_QUESTION_FILTER_CHOICES_Q2_1,
      filterChoicesQ2_1: matchedElementKeys,
    });

    // }
  };

  setFilterChoicesQ6 = () => {
    // F4E399AA-D0E0-47DE-B793-ACC53FAB4ECF
    const { answers } = this.props;

    const question6 = json.question6;
    const answerId = '569FE152-1A10-4D4B-B21A-8BFA5CB2B706';
    const checkedItems =
      answers[answerId]?.value?.filter((item) => item.checkState) || [];
    // ดึงเฉพาะ elementKey ที่ถูก checkState: true

    const selectedKeys = checkedItems.map((item) => item.elementKey);

    // หาจาก question6 ที่ตรงกับ selectedKeys แล้วดึง mapkey
    const selectedMapKeys = question6
      .filter((item) => selectedKeys.includes(item.elementKey))
      .map((item) => item.mapkey);

    store.dispatch({
      type: CONDUCT_QUESTION_FILTER_CHOICES_Q6,
      filterChoicesQ6: selectedMapKeys,
    });
  };

  setFilterChoicesQ6Tourist = () => {
    const pathParts = window.location.pathname.split('/');
    const id = pathParts[1]; // index 0 คือ '', index 1 คือ '1'
    const selectedLocation = this.getLocation(id);
    const locationData = json.location;
    const locationElementKey =
      locationData.find((loc) => Object.keys(loc)[0] === selectedLocation)?.[
        selectedLocation
      ]?.choiceQ6Tourist || '';

    store.dispatch({
      type: CONDUCT_QUESTION_FILTER_CHOICES_Q6_TOURIST,
      filterChoicesTouristQ6: locationElementKey,
    });
  };

  setFilterChoicesQ3Tourist = () => {
    const pathParts = window.location.pathname.split('/');
    const id = pathParts[1]; // index 0 คือ '', index 1 คือ '1'

    const selectedLocation = this.getLocation(id);

    const locationData = json.location;
    const question3_tourist = json.question3_tourist;

    const locationCodes =
      locationData.find((loc) => Object.keys(loc)[0] === selectedLocation)?.[
        selectedLocation
      ]?.codesQ3Tourist || [];

    const getElementKeys = question3_tourist.filter((q) =>
      locationCodes.includes(q.code),
    );

    const codeToElementKeyMap = question3_tourist.reduce((acc, obj) => {
      acc[obj.code] = obj.elementKey;
      return acc;
    }, {});

    const matchedElementKeys = getElementKeys.map(
      (c) => codeToElementKeyMap[c.code],
    );

    store.dispatch({
      type: CONDUCT_QUESTION_FILTER_CHOICES_Q3_TOURIST,
      filterChoicesTouristQ3: matchedElementKeys,
    });

    // }
  };

  createSurveyFlow(newQuestions, context, nodes) {
    const { answers } = this.props;

    return nodes.map((nodeSurveyFlow, indexKey) => {
      if (nodeSurveyFlow.type === QUESTION) {
        let nodeQuestion = newQuestions.filter(
          (q) => q.elementKey === nodeSurveyFlow.elementKey,
        );

        if (!nodeQuestion[0]) {
          throw new Error('Not found question = ' + nodeSurveyFlow.elementKey);
        }

        return this.pushComponentsToArray(
          nodeSurveyFlow,
          nodeQuestion[0],
          answers,
          newQuestions,
          indexKey,
          context,
        );
      } else if (nodeSurveyFlow.type === GROUP) {
        return (
          <GroupsContainer
            key={'groupscontainer' + nodeSurveyFlow.elementKey}
            nodes={nodeSurveyFlow}
            showButton={false}
          />
        );
      }
      return null;
    });
  }
  getAnswer = (elementKey, defaultValue) => {
    const { answers } = this.props;
    if (Object.keys(answers).indexOf(elementKey) >= 0) {
      return answers[elementKey];
    }

    return defaultValue;
  };
  nodeList() {
    const { questions, answers, conduct } = this.props;

    let newQuestions = questions;
    const self = this;
    let context = Exp.survey_conduct_context(
      newQuestions,
      answers,
      conduct.contextVariables,
    );
    // Remove Answer and progress
    return this.props.nodes.map((nodeSurveyFlow, indexKey) => {
      if (nodeSurveyFlow.type === QUESTION) {
        let nodeQuestion = newQuestions.filter((a, b) => {
          return a.elementKey === nodeSurveyFlow.elementKey;
        });
        if (!nodeQuestion[0]) {
          throw new Error('Not found question = ' + nodeSurveyFlow.elementKey);
        }
        return self.pushComponentsToArray(
          nodeSurveyFlow,
          nodeQuestion[0],
          answers,
          newQuestions,
          indexKey,
          context,
        );
      } else if (nodeSurveyFlow.type === GROUP) {
        return (
          <GroupsContainer
            key={'groupscontainer' + nodeSurveyFlow.elementKey}
            nodes={nodeSurveyFlow}
            showButton={false}
          />
        );
      }
      return '';
    });
  }
  finParentPage(data) {
    if (isNullOrUndefined(data)) return false;
    const { surveyFlowArrayLine } = this.props.conduct;
    if (data.type === PAGE) {
      return data;
    }
    const flow = surveyFlowArrayLine.find((x) => x.id === data.parentID);
    if (isNullOrUndefined(flow)) return false;
    return this.finParentPage(flow);
  }
  keepStateAutoNext(nodeSurveyFlow, node) {
    const pageParentQuestions = this.finParentPage(nodeSurveyFlow);
    if (pageParentQuestions === false) return false;
    addAutoNextToStore(pageParentQuestions.elementKey, node.elementKey);
    return true;
  }
  removeKeepStateAutoNext(nodeSurveyFlow, keepStateAutoNext) {
    const pageParentQuestions = this.finParentPage(nodeSurveyFlow);
    removeAutoNextToStore(pageParentQuestions.elementKey, keepStateAutoNext);
  }
  pushComponentsToArray(
    nodeSurveyFlow,
    node,
    answers,
    questions,
    indexKey,
    context,
  ) {
    let publishKey = this.props.conduct.key;

    let keepQuestionElement = node.elementKey;
    // function check condition to show hide
    let elementKey = node.elementKey + nodeSurveyFlow.id;
    if (nodeSurveyFlow && context) {
      if (!Exp.run_object_context(nodeSurveyFlow.condition, context)) {
        //Remove
        this.removeKeepStateAutoNext(nodeSurveyFlow, keepQuestionElement);
        return '';
      }
    }
    this.keepStateAutoNext(nodeSurveyFlow, node);
    if (node.type === SINGLELINETEXT) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <SingleLineTextComponent
          key={SINGLELINETEXT + elementKey}
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByElement}
        />
      );
    } else if (node.type === MULTIPLELINETEXT) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <MultipleLineTextComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByElement}
          key={MULTIPLELINETEXT + elementKey}
        />
      );
    } else if (node.type === DISPLAYMESSAGE) {
      return (
        <DisplayMessageComponent
          question={node}
          key={DISPLAYMESSAGE + elementKey}
        />
      );
    } else if (node.type === NUMBER) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <NumericComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerNumberByElement}
          key={NUMBER + elementKey}
        />
      );
    } else if (node.type === RANKING) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <RankingComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValueArray}
          key={RANKING + elementKey}
        />
      );
    } else if (node.type === RATING) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <RatingComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValue}
          key={RATING + elementKey}
        />
      );
    } else if (node.type === RATINGSCALE) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <RatingScaleComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValue}
          key={RATINGSCALE + elementKey}
        />
      );
    } else if (node.type === DROPDOWNLIST) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <DropdownListComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValue}
          key={DROPDOWNLIST + elementKey}
          setLanguages={this.props.setLanguages}
          publishKey={publishKey}
          conduct={this.props.conduct}
        />
      );
    } else if (node.type === NETPROMOTORSCORE) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <NetPromotorScoreComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValue}
          key={NETPROMOTORSCORE + elementKey}
        />
      );
    } else if (node.type === MULTIPLECHOICEONE) {
      let answer = {};
      if (node.includeOther) {
        answer = this.getAnswer(node.elementKey, {
          isIncludeOther: false,
          IncludeOtherText: '',
          value: [],
          error: '',
        });
      } else {
        answer = this.getAnswer(node.elementKey, {
          value: [],
          error: '',
        });
      }
      return (
        <MultipleChoiceOneComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValueArrayOneChoice}
          key={MULTIPLECHOICEONE + elementKey}
          setLanguages={this.props.setLanguages}
          publishKey={publishKey}
          conduct={this.props.conduct}
          getAnswer={this.getAnswer}
        />
      );
    } else if (node.type === MULTIPLECHOICESINGLELINETEXT) {
      let answer = this.getAnswer(node.elementKey, {
        isIncludeOther: false,
        IncludeOtherText: '',
        value: [],
        error: '',
      });

      return (
        <MultipleChoiceSingleLineTextComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValueArrayMutiple}
          key={MULTIPLECHOICESINGLELINETEXT + elementKey}
        />
      );
    } else if (node.type === MULTIPLECHOICEMULTIPLE) {
      let answer = {};
      if (node.includeOther) {
        answer = this.getAnswer(node.elementKey, {
          isIncludeOther: false,
          IncludeOtherText: '',
          value: [],
          error: '',
        });
      } else {
        answer = this.getAnswer(node.elementKey, {
          value: [],
          error: '',
        });
      }
      return (
        <MultipleChoiceMultipleComponent
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByValueArrayMutiple}
          key={MULTIPLECHOICEMULTIPLE + elementKey}
          currentLanguageID={this.props.conduct.currentLanguageID}
          conduct={this.props.conduct}
        />
      );
    } else if (node.type === PHONE_SINGLELINETEXT) {
      const answer = this.getAnswer(node.elementKey, { value: '', error: '' });
      return (
        <PhoneComponent
          key={PHONE_SINGLELINETEXT + elementKey}
          question={node}
          answer={answer}
          setAnswer={this.props.setAnswerByElement}
        />
      );
    }
  }

  render() {
    const { questions, answers, conduct } = this.props;
    const { currentNode, surveyFlowQ5 } = conduct;
    const { surveyFlow } = this.state;

    let newQuestions = questions;
    let context = Exp.survey_conduct_context(
      newQuestions,
      answers,
      conduct.contextVariables,
    );

    if (currentNode.elementKey === '748C8E3D-D149-4A56-A90B-23D838F7D9B7') {
      return (
        surveyFlowQ5 &&
        this.createSurveyFlow(newQuestions, context, surveyFlowQ5)
      );
    } else {
      return (
        surveyFlow && this.createSurveyFlow(newQuestions, context, surveyFlow)
      );
    }
  }
  // render() {
  //   return this.nodeList();
  // }
}

const mapStateToProps = (state) => {
  return {
    conduct: state.conductReducer,
    answers: state.answerReducer.data,
    questions: state.conductReducer.questions
      ? state.conductReducer.questions
      : [],
    page: state.conductReducer.page,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAnswerByValue: (props, value) => {
      validateRequireSetValue(props, value, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerByElement: (props, event) => {
      validateRequire(props, event, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerNumberByElement: (props, event) => {
      validateNumberRequire(props, event, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerByValueArray: (props, value) => {
      validateRequireSetValueArray(props, value, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerByValueArrayOneChoice: (props, value) => {
      validateRequireSetValueMultipleChoiceOne(props, value, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerByValueArrayMutiple: (props, value) => {
      validateRequireSetValueMultipleChoiceMultiple(props, value, dispatch);
      autoNextCheckQuestion();
    },
    setAnswerByValueArrayMatrix: (props, value, singleLine = false) => {
      validateRequireSetValueArrayMatrix(props, value, dispatch, singleLine);
      autoNextCheckQuestion();
    },
    setAnswerEmpty: (key, data) => {
      dispatch(setWrapper(key, data));
      autoNextCheckQuestion();
    },
    setLanguages: (key, languageID) => {
      let path = `survey/language/${languageID}`;
      dispatch(setLanguages(path));

      // let path = 'survey-language';
      // dispatch(
      //   setLanguages(path + `?key=${key}&type=publish&lang=${languageID}`),
      // );
    },

    setConductQuestionRandom: (questionRandom) => {
      dispatch(setConductQuestionRandom(questionRandom));
    },
    setConductSurveyFlowQ5: (surveyFlowQ5) => {
      dispatch(setConductSurveyFlowQ5(surveyFlowQ5));
    },
    setConductSurveyQuestions: (surveyQuestions) => {
      dispatch(setConductSurveyQuestions(surveyQuestions));
    },
    setConductCountryOptions: (options) => {
      dispatch(setConductCountryOptions(options));
    },
    setConductFilterChoicesQ2_1: (options) => {
      dispatch(setConductFilterChoicesQ2_1(options));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NodeContainer);
